/* Mirror the native drawer accordion state for assistive technology. No cart actions. */
(() => {
  'use strict';
  const initialize = () => {
    document.querySelectorAll('.igneous-cart-drawer button[data-accordion-trigger]').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      const panelId = button.getAttribute('aria-controls');
      if (!panelId || !document.getElementById(panelId)) return;
      const synchronize = () => {
        button.setAttribute('aria-expanded', String(button.classList.contains('accordion-is-open')));
      };
      button.removeAttribute('aria-haspopup');
      synchronize();
      if (button.hasAttribute('data-igneous-disclosure-observed')) return;
      button.setAttribute('data-igneous-disclosure-observed', '');
      new MutationObserver(synchronize).observe(button, { attributes: true, attributeFilter: ['class'] });
    });
  };
  initialize();
  if (document.documentElement.hasAttribute('data-igneous-disclosures-installed')) return;
  document.documentElement.setAttribute('data-igneous-disclosures-installed', '');
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  ['theme:section:load', 'theme:section:update'].forEach((name) => window.addEventListener(name, initialize));
  document.addEventListener('shopify:section:load', initialize);
})();
